export const environment = {
  "production": false,
  "baseUrl": "https://dev.portalaliados.puntoaliado.com/",
  "idAccountHubspot": "50104745",
  "azureConfig": {
      "METADATACONTENT": "https://login.microsoftonline.com/cfbb8354-b4b1-42f3-9078-62e54be9af3f/federationmetadata/2007-06/federationmetadata.xml?appid=c8fffca1-5d92-4930-9fba-0062795f5b27"
  },
  "cognitoConfig": {
      "REDIRECTSIGNINURIS": [
          "https://dev.portalaliados.puntoaliado.com/auth/callback"
      ],
      "REDIRECTSIGNOUTURIS": [
          "https://dev.portalaliados.puntoaliado.com/"
      ],
      "USERPOOLID": "us-east-1_PeGtOmeAI",
      "CLIENTID": "6qt5j14pkk76k4gel7lvd9cuv4",
      "CLIENTSECRET": "1hpu4280v55p0bn3n7oo1se254pha53n2u5g81vkm8kh9hkrqfps",
      "AWSREGION": "us-east-1",
      "DOMAIN": "portal-aliados-auth-dev.auth.us-east-1.amazoncognito.com",
      "IDENTITYPOOLID": "us-east-1:140q9ju1tuote627l9nb48dpn1a0gr7v7dmi0s9rtau7ispo6qjt"
  },
  "microservices": {
      "msconfiguracionaplicacion": "https://dev.fidel.puntoaliado.com/"
  },
  "environmentPrefix": "azuread_",
  "secretKey": "#FiD3L/pUnT04l1aDo*Dev",
  "environmentGroup": "DEVELOPMENT",
  "enableSSO": true,
  "portalAliadosUrl": "https://dev-auth.portal-aliados.puntoaliado.com/login",
  "portalAliadosLogoutUrl": "https://dev-auth.portal-aliados.puntoaliado.com/logout?post_logout_redirect_uri=https://dev.portalaliados.puntoaliado.com"
};
